import { useQuery } from "react-query";
import axiosInstance from "./axiosInstance";
import { BlockUserListRes } from "../../types/BlockUserListType";

export const useBlockUserList = () => {
  return useQuery<BlockUserListRes, Error>(
    ["block/block-list"],
    async () => {
      const response = await axiosInstance.post<BlockUserListRes>("block/block-list", {});
      return response.data;
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity,
    },
  );
};
